// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import VueSmoothScroll from 'vue-smooth-scroll'

Vue.use(Vuetify)
Vue.use(VueSmoothScroll)

Vue.config.productionTip = false

Vue.component('Unity', require('vue-unity-webgl'))

new Vue({
  el: '#app',
  router,
  store,
  created () {
    store.dispatch('loadSchools')
    store.dispatch('loadSchoolsResult', null)
  },
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js